import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseProductCategoriesProps<T> = {
  filters?: {
    search?: string
    page?: number
    sort?: Partial<Record<string, 'asc' | 'desc'>>
  }
  mapper?: (data: any) => T,
}

export const useProductCategories = <T,>({
  filters: { search = '', page, sort } = {},
  mapper = Mapper.default<T>(),
}: UseProductCategoriesProps<T>) => {
  const privateAxios = usePrivateAxios()
  const sortKey = sort ? JSON.stringify(sort) : undefined

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['productCategories', search, page, sortKey],
    queryFn: () => {
      return privateAxios.get('/product_categories', {
        params: {
          search,
          page,
          sort,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
